import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { grey } from '@material-ui/core/colors';
import { green } from '@material-ui/core/colors';
import FormControl from '@material-ui/core/FormControl';
import Grow from '@material-ui/core/Grow';
import Input from '@material-ui/core/Input';
import LinearProgress from '@material-ui/core/LinearProgress';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { isNull } from 'util';
import {
	IDetailData,
	IDivisionData,
	IFetchHistoryJoken,
	IFetchJoken,
	ILevelData,
	IMasterInfo,
	ISkillMapHistory,
	ITargetSetParam,
	IUpdateInfo,
} from '../actions/skillMap';
import { IRootState } from '../reducers';
import { ISkillMapState } from '../reducers/skillMap';
import i18n from '../resources/i18n';
import SkillMapScenarioFactory from '../scenario/SkillMapScenarioFactory';
import { isMobile } from '../utils/MobileCheck';
import MessageDialog from './MessageDialog';
import SkillMapHistory from './SkillMapHistory';
import SkillMapTargetSet from './SkillMapTargetSet';
const styles = (theme: Theme) =>
	createStyles({
		baseAction: {
			alignItems: 'center',
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			width: '100%',
		},
		baseArea: {
			display: 'flex',
			flexDirection: 'column',
		},
		baseContent: {
			backgroundColor: '#fafafa',
			display: 'flex',
			flexDirection: 'column',
			height: 'calc(100vh - 235px)',
			minHeight: '34px',
			overflow: 'auto',
			position: 'relative',
			width: '100%',
		},
		baseContent1: {
			backgroundColor: '#fafafa',
			display: 'flex',
			flexDirection: 'column',
			height: 'calc(100vh - 235px)',
			minHeight: '34px',
			overflow: 'auto',
			position: 'relative',
			width: '99%',
		},
		baseTitle: {
			display: 'flex',
			flexDirection: 'row',
			width: '100%',
		},
		buttonProgress: {
			color: green[500],
			left: '50%',
			marginLeft: '-12px',
			marginTop: '-12px',
			position: 'absolute',
			top: '50%',
		},
		buttonProgress2: {
			color: green[500],
			left: '40%',
			position: 'absolute',
			top: '3px',
		},
		careeDetail: {
			cursor: 'default',
			overflow: 'hidden',
			textIndent: '20px',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			wordBreak: 'break-all',
		},
		container: {
			display: 'flex',
			left: '0px',
			position: 'absolute',
			top: '0px',
		},
		division1: {
			alignItems: 'center',
			borderRadius: '5px',
			boxShadow: '4px 4px 4px #888888',
			cursor: 'default',
			display: 'flex',
			height: '40px',
			justifyContent: 'center',
			marginBottom: '10px',
			marginLeft: '5px',
			marginRight: '5px',
			marginTop: '10px',
			minWidth: '150px',
			textAlign: 'center',
		},
		division2: {
			alignItems: 'center',
			borderRadius: '5px',
			boxShadow: '4px 4px 4px #888888',
			cursor: 'default',
			display: 'flex',
			height: '40px',
			justifyContent: 'center',
			marginBottom: '10px',
			marginLeft: '5px',
			marginRight: '5px',
			marginTop: '10px',
			minWidth: '150px',
			textAlign: 'center',
		},
		division3: {
			alignItems: 'center',
			borderRadius: '5px',
			boxShadow: '4px 4px 4px #888888',
			cursor: 'default',
			display: 'flex',
			height: '40px',
			justifyContent: 'center',
			marginBottom: '10px',
			marginLeft: '5px',
			marginRight: '5px',
			marginTop: '10px',
			minWidth: '150px',
			textAlign: 'center',
		},
		divisionBlank: {
			minWidth: '150px',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			wordBreak: 'break-all',
		},
		divisionText: {
			overflow: 'hidden',
			padding: '3px 3px',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			wordBreak: 'break-all',
		},
		ellipsisText: {
			minWidth: '20px',
			overflow: 'hidden',
			padding: '3px 3px',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			wordBreak: 'break-all',
		},
		formControl: {
			margin: theme.spacing(1),
			minWidth: 120,
		},
		legendCircle: {
			borderRadius: '50%',
		},
		legendIcon: {
			alignItems: 'center',
			display: 'flex',
			padding: '0px 5px',
		},
		levelCell: {
			backgroundColor: '#fff',
			border: '2px solid rgba(0,0,0,0)',
			boxShadow: '4px 4px 4px #888888',
			cursor: 'pointer',
			display: 'flex',
			flexDirection: 'column',
		},
		levelCellBase: {
			alignItems: 'center',
			display: 'flex',
			flex: 1,
			fontWeight: 'bold',
			height: '90px',
			justifyContent: 'center',
			marginBottom: '10px',
			marginLeft: '5px',
			marginRight: '5px',
			marginTop: '10px',
			minWidth: '150px',
			textAlign: 'center',
			width: '180px',
		},
		levelCellBlank: {
			border: '2px solid rgba(0,0,0,0)',
		},
		levelCellSelected: {
			border: '2px solid #2196f3',
		},
		paper: {
			fontSize: '12px',
			margin: 0,
			padding: '5px 5px',
		},
		polygon: {
			fill: theme.palette.common.white,
			stroke: theme.palette.divider,
			strokeWidth: 1,
		},
		root: {
			flexGrow: 1,
			padding: theme.spacing(1),
			position: 'relative',
		},
		svg: {
			height: 10,
			width: 10,
		},
		table: {
			backgroundColor: '#FFF',
			tableLayout: 'fixed',
		},
		tableTitle: {
			minWidth: '20px',
			overflow: 'hidden',
			padding: '3px 3px',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			wordBreak: 'break-all',
		},
	});

/**
 * 分野データインターフェイス
 */
interface IDData extends IDivisionData {
	/**
	 * レベルデータ
	 */
	lDatas: ILevelData[];
}

/**
 * ツリーデータインターフェイス
 */
interface ISkillMapTree {
	/**
	 * 分野データ
	 */
	data: IDData;

	/**
	 * 分野データ以下の分野データ
	 */
	child: ISkillMapTree[];
}

/**
 * 表示用分野データ
 */
interface IDisDivision {
	/**
	 * 分野ソート順
	 */
	order: number;

	/**
	 * 当前分野以下の分野数（分野直下のレベルも計算した）
	 */
	count: number;

	/**
	 * 分野名
	 */
	fieldTitle: string;

	/**
	 * 補足分野フラグ
	 */
	blank: boolean;

	/**
	 * 分野ID
	 */
	fieldID: string;
}

/**
 * 表示用分野データ
 */
interface IDisDivisionData {
	/**
	 * 分野データ
	 */
	data: IDisDivision;

	/**
	 * 分野データ以下の分野データ
	 */
	child: IDisDivisionData[];
}

/**
 * 表示用レベルデータ
 */
interface IDisLevelData {
	/**
	 * レベル名
	 */
	levelTitle: string;

	/**
	 * レベルの説明
	 */
	contents: string;

	/**
	 * セルの背景色
	 */
	bg: string;

	/**
	 * 目標アイコン
	 */
	icon: string;

	/**
	 * セル選択フラグ
	 */
	select: boolean;

	/**
	 * レベル
	 */
	level: string;

	/**
	 * レベルソートキー
	 */
	sKey: string;

	/**
	 * 補足レベルフラグ
	 */
	blank: boolean;

	/**
	 * キャリアマップセルID
	 */
	cmcId: string;

	/**
	 * 分野ID
	 */
	fieldId: string;

	/**
	 * 目標値
	 */
	targetType: number;

	/**
	 * セルコメント
	 */
	comment: string;
}

/**
 * 表示用レベルデータ
 */
interface IDisLevelList {
	/**
	 * ルートID
	 */
	id: string;

	/**
	 * ルート以下のレベルデータ
	 */
	datas: IDisLevelData[][];
}

/**
 * キャリアマップ部品公開プロパティー定義
 */
export interface ISkillMapProp {
	/**
	 * キャリアマップID
	 */
	cmId: string;
	AdminView: boolean;
	targetUserId?: string;
}

/**
 * キャリアマップ部品内部状態定義
 */
interface IState {
	/**
	 * セル詳細表示フラグ
	 */
	open: boolean;

	/**
	 * 分野１データ
	 */
	rootDivision: any[];

	/**
	 * 選択したの分野１Id
	 */
	selectDivision: string;

	/**
	 * 選択したセルID
	 */
	selectLevelId: string;

	/**
	 * 表示用全部分野データ
	 */
	disDiviArr: IDisDivisionData[];

	/**
	 * 表示用全部レベルデータ
	 */
	disLeveArr: IDisLevelList[];

	/**
	 * 現在表示な分野データ
	 */
	disNowDiviData: IDisDivisionData;

	/**
	 * 現在表示なレベルデータ
	 */
	disNowLeveData: IDisLevelData[][];

	/**
	 * マスタ設定したの色
	 */
	masterInfo: IMasterInfo;

	/**
	 * 最後更新ユーザ情報
	 */
	updateInfo: IUpdateInfo;

	/**
	 * セル表示位置情報
	 */
	popupInfo: any;

	/**
	 * セル詳細優先部分
	 */
	detailDataS: IDetailData[];

	/**
	 * セル詳細優先以外部分
	 */
	detailDataN: IDetailData[];

	/**
	 * セル表示位置情報
	 */
	arrow: any;

	/**
	 * 最大セル列数
	 */
	maxCols: number;

	/**
	 * 最大レベル数
	 */
	maxRows: number;

	/**
	 * loading
	 */
	loading: boolean;

	/**
	 * loading
	 */
	hloading: boolean;

	/**
	 * loading
	 */
	dloading: boolean;

	/**
	 * 目標設定画面表示フラグ
	 */
	popOpen: boolean;

	/**
	 * 目標設定画面データ
	 */
	targetParam: ITargetSetParam;

	/**
	 * メッセージ表示フラグ
	 */
	msgOpen: boolean;

	/**
	 * メッセージタイトル
	 */
	msgTitle: string;

	/**
	 * メッセージ内容
	 */
	msgCodes: any[];

	/**
	 * メッセージ取消ボタンフラグ
	 */
	msgCancel: boolean;

	/**
	 * 更新履歴画面表示フラグ
	 */
	historyOpen: boolean;

	/**
	 * 更新履歴画面データ
	 */
	historyData: ISkillMapHistory[];

	/**
	 * IE問題対応フラグ
	 */
	zoneFlg: boolean;

	/**
	 * 認定条件が未設定です。
	 */
	levelInfoNone: string;
}

/**
 * ツールTIP　ARROW　HEIGHT
 */
const ARROW_HEIGHT = 10;
/**
 * ツールTIP　ARROW　WIDTH
 */
const ARROW_WIDTH = 10;
/**
 * ツールTIP　HEIGHT
 */
const TIP_HEIGHT = 160;
/**
 * ツールTIP　WIDTH
 */
const TIP_WIDTH = 300;
/**
 * 画面WIDTH
 */
const WINDOW_WIDTH = 500;

class SkillMap extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		/**
		 * 画面状態初期化
		 */
		this.state = {
			arrow: { x: 0, y: 0, path: '' },
			detailDataN: [],
			detailDataS: [],
			disDiviArr: [],
			disLeveArr: [],
			disNowDiviData: {
				child: [],
				data: {
					blank: true,
					count: 0,
					fieldID: '',
					fieldTitle: '',
					order: 0,
				},
			},
			disNowLeveData: [],
			dloading: false,
			historyData: [],
			historyOpen: false,
			hloading: false,
			levelInfoNone: '',
			loading: false,
			masterInfo: {
				division1Color: '#90caf9',
				division2Color: '#bbdefb',
				division3Color: '#e3f2fd',
				goalCompleteColor: '#fce4ec',
				longGoalColor: '#4caf50',
				shortGoalColor: '#ffd600',
			},
			maxCols: 0,
			maxRows: 0,
			msgCancel: false,
			msgCodes: [],
			msgOpen: false,
			msgTitle: '',
			open: false,
			popOpen: false,
			popupInfo: { x: 0, y: 0 },
			rootDivision: [{ label: i18n.t('SkillMap_0001'), value: 'emp' }],
			selectDivision: 'emp',
			selectLevelId: '',
			targetParam: {
				adminView: false,
				cellLabel: '',
				cmId: '',
				cmcId: '',
				comment: '',
				target: 0,
				userId: '',
			},
			updateInfo: {
				skillMapName: '',
				updateTime: '',
				updator: '',
			},
			zoneFlg: false,
		};
		this.handlePopClose = this.handlePopClose.bind(this);
		this.handleHistoryClose = this.handleHistoryClose.bind(this);
		this.handleCellClick = this.handleCellClick.bind(this);
	}

	/**
	 * 部品初期化
	 */
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		this.setState({ dloading: true });
		const type = isMobile() ? 'orientationchange' : 'resize';
		window.addEventListener(type, this.resizeWrapper);
		if ('ActiveXObject' in window) {
			this.setState({ zoneFlg: false });
		} else {
			this.setState({ zoneFlg: true });
		}
		/**
		 * マップデータを取得する。
		 */
		this.props
			.fetchSkillMapData(this.props.token, {
				cmId: this.props.cmId,
				userId: this.props.AdminView
					? this.props.targetUserId
					: this.props.userId,
			})
			.then(data => {
				// マスタデータと最後更新情報に状態を設定する。
				this.setState({
					masterInfo: this.props.skillMapData.masterData,
					rootDivision: this.props.skillMapData.rootDivision,
					updateInfo: this.props.skillMapData.updateInfo,
				});

				// 取得したのスキルマップデータに表示用なデータを変換する。
				this.initData(
					this.props.skillMapData.divisionData,
					this.props.skillMapData.levelData,
					this.props.skillMapData.rootDivision
				);
			});
	}

	public componentWillUnmount() {
		const type = isMobile() ? 'orientationchange' : 'resize';
		window.removeEventListener(type, this.resizeWrapper);
	}

	/**
	 * 部品レイアウトレンダリング
	 */
	public render() {
		const { classes } = this.props;
		return (
			<div className={classes.root} style={{ minWidth: WINDOW_WIDTH }}>
				<MessageDialog
					open={this.state.msgOpen}
					showCancelButton={this.state.msgCancel}
					title={this.state.msgTitle}
					contents={this.state.msgCodes}
					onClose={this.handleMsgClose}
					onClickOk={this.handleMsgOk}
				/>
				<SkillMapTargetSet
					open={this.state.popOpen}
					param={this.state.targetParam}
					// tslint:disable-next-line: jsx-no-bind
					onClose={this.handlePopClose.bind(this)}
				/>
				<SkillMapHistory
					open={this.state.historyOpen}
					history={this.state.historyData}
					// tslint:disable-next-line: jsx-no-bind
					onClose={this.handleHistoryClose.bind(this)}
				/>
				<div className={classes.baseArea}>
					<div className={classes.baseTitle}>
						<div
							style={{
								boxShadow: '2px 1px rgba(127,127,127,0.1)',
								flex: 2,
							}}
						>
							<Table
								className={classes.table}
								aria-label="a dense table"
								size="small"
							>
								<TableHead>
									<TableRow
										style={{
											backgroundColor: grey[300],
										}}
									>
										<TableCell align="left">
											<div
												className={classes.tableTitle}
												title={
													i18n.t('SkillMap_0002') +
													'：'
												}
											>
												{i18n.t('SkillMap_0002')}：
											</div>
										</TableCell>
										<TableCell align="left">
											<div
												className={classes.tableTitle}
												title={
													i18n.t('SkillMap_0003') +
													'：'
												}
											>
												{i18n.t('SkillMap_0003')}：
											</div>
										</TableCell>
										<TableCell
											align="left"
											className={classes.tableTitle}
										>
											<div
												className={classes.tableTitle}
												title={i18n.t('SkillMap_0004')}
											>
												{i18n.t('SkillMap_0004')}
											</div>
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									<TableRow>
										<TableCell
											align="left"
											className={classes.tableTitle}
										>
											<div
												className={classes.tableTitle}
												title={
													this.state.updateInfo
														.skillMapName
												}
											>
												{
													this.state.updateInfo
														.skillMapName
												}
											</div>
										</TableCell>
										<TableCell
											align="left"
											className={classes.tableTitle}
										>
											<div
												className={classes.tableTitle}
												title={
													this.state.updateInfo
														.updator
												}
											>
												{this.state.updateInfo.updator}
											</div>
										</TableCell>
										<TableCell
											align="left"
											className={classes.tableTitle}
										>
											<div
												className={classes.tableTitle}
												title={
													this.state.updateInfo
														.updateTime
												}
											>
												{
													this.state.updateInfo
														.updateTime
												}
											</div>
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</div>
						<div
							style={{
								alignItems: 'center',
								display: 'flex',
								flex: 1,
								flexDirection: 'row',
								justifyContent: 'flex-end',
							}}
						>
							<div
								style={{
									alignSelf: 'flex-end',
									display: 'flex',
									justifyContent: 'flex-start',
									marginLeft: '20px',
									position: 'relative',
									width: '100%',
								}}
							>
								<div style={{ position: 'relative' }}>
									<Button
										size="small"
										variant="contained"
										onClick={this.handleHistoryClick}
										disabled={this.state.hloading}
										className={classes.ellipsisText}
										title={i18n.t('SkillMap_0005')}
									>
										{i18n.t('SkillMap_0005')}
									</Button>
									{this.state.hloading && (
										<CircularProgress
											size={24}
											className={classes.buttonProgress2}
										/>
									)}
								</div>
							</div>
							<div
								style={{
									border: '1px solid #ccc',
									borderRadius: '4px',
									justifySelf: 'flex-end',
									position: 'relative',
								}}
							>
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										height: '60px',
										justifyContent: 'space-around',
									}}
								>
									<div className={classes.legendIcon}>
										<div
											className={classes.legendCircle}
											style={{
												backgroundColor: this.state
													.masterInfo.shortGoalColor,
												height: '10px',
												width: '10px',
											}}
										/>
										<div
											className={classes.ellipsisText}
											title={i18n.t('SkillMap_0006')}
										>
											{i18n.t('SkillMap_0006')}
										</div>
									</div>
									<div className={classes.legendIcon}>
										<div
											className={classes.legendCircle}
											style={{
												backgroundColor: this.state
													.masterInfo.longGoalColor,
												height: '10px',
												width: '10px',
											}}
										/>
										<div
											className={classes.ellipsisText}
											title={i18n.t('SkillMap_0007')}
										>
											{i18n.t('SkillMap_0007')}
										</div>
									</div>
									<div className={classes.legendIcon}>
										<div
											style={{
												backgroundColor: this.state
													.masterInfo
													.goalCompleteColor,
												borderRadius: '3px',
												height: '10px',
												width: '25px',
											}}
										/>
										<div
											className={classes.ellipsisText}
											title={i18n.t('SkillMap_0008')}
										>
											{i18n.t('SkillMap_0008')}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className={classes.baseAction}>
						<div
							style={{
								alignItems: 'center',
								display: 'flex',
								flexDirection: 'row',
							}}
						>
							<div>{i18n.t('SkillMap_0009')}</div>
							<FormControl className={classes.formControl}>
								<Select
									input={
										<Input
											name="sdivision"
											id="sdivision"
										/>
									}
									id="sdivision"
									value={this.state.selectDivision}
									onChange={this.handleChange}
								>
									{this.state.rootDivision.map((obj, ri) => {
										return (
											<MenuItem
												key={ri}
												value={obj.value}
											>
												{obj.label}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</div>
						<div
							style={{
								display:
									this.props.skillMapData.applyFlg === 2
										? 'none'
										: '',
							}}
						>
							<Button
								size="small"
								style={{ width: '94px', marginRight: '15px' }}
								variant="contained"
								color="primary"
								onClick={this.handleTargetSetClick}
							>
								{i18n.t('SkillMap_0010')}
							</Button>
							<Button
								size="small"
								variant="contained"
								onClick={this.handleTargetReSetClick}
							>
								{i18n.t('SkillMap_0011')}
							</Button>
						</div>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							height: '4px',
						}}
					>
						<LinearProgress hidden={!this.state.dloading} />
					</div>
					<div
						className={
							this.state.zoneFlg
								? classes.baseContent
								: classes.baseContent1
						}
					>
						<div
							className={classes.container}
							style={{
								left: this.state.popupInfo.x,
								top: this.state.popupInfo.y,
								zIndex: this.state.open === true ? 1 : -1,
							}}
						>
							<Grow
								in={this.state.open}
								style={{ transformOrigin: '0 0 0' }}
								{...(this.state.open ? { timeout: 500 } : {})}
							>
								<div style={{ position: 'relative' }}>
									<svg
										className={classes.svg}
										style={{
											left: this.state.arrow.x,
											position: 'absolute',
											top: this.state.arrow.y,
										}}
									>
										<polygon
											points={this.state.arrow.path}
											className={classes.polygon}
										/>
									</svg>
									<Paper
										elevation={4}
										className={classes.paper}
										style={{
											height: TIP_HEIGHT,
											marginLeft: this.state.arrow
												.offsetLeft,
											overflowY: 'auto',
											width: TIP_WIDTH,
										}}
									>
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
											}}
										>
											{this.state.levelInfoNone !==
												'' && (
												<div
													style={{
														display: 'flex',
														flexDirection: 'column',
													}}
												>
													<div
														style={{
															cursor: 'default',
															overflow: 'hidden',
															textIndent: '30px',
															textOverflow:
																'ellipsis',
															whiteSpace:
																'nowrap',
															wordBreak:
																'break-all',
														}}
													>
														{
															this.state
																.levelInfoNone
														}
													</div>
												</div>
											)}
											{this.state.detailDataS.length >
												0 && (
												<div
													style={{
														display: 'flex',
														flexDirection: 'column',
													}}
												>
													<div
														style={{
															fontWeight: 'bold',
														}}
													>
														{i18n.t(
															'SkillMap_0012'
														)}
													</div>
													{this.state.detailDataS.map(
														ds => {
															const Flg1: boolean =
																ds.careerTypeID ===
																	'90' &&
																ds.statusId ===
																	'4';
															const Flg2: boolean =
																ds.careerTypeID !==
																	'90' &&
																(ds.statusNum ===
																	7 ||
																	ds.statusNum ===
																		17);
															const title =
																ds.careerTitle +
																'【' +
																(ds.careerType ===
																	'eラーニング' ||
																ds.careerType ===
																	'集合研修' ||
																ds.careerType ===
																	'通信教育' ||
																ds.careerType ===
																	'カリキュラム' ||
																ds.careerType ===
																	'資格' ||
																ds.careerType ===
																	'業務経験' ||
																ds.careerType ===
																	'スキル診断'
																	? i18n.t(
																			ds.careerType,
																			{
																				ns:
																					'force',
																			}
																	  )
																	: ds.careerType) +
																'】' +
																(ds.rankName
																	? '(' +
																	  ds.rankName +
																	  ds.rankName +
																	  ')'
																	: '') +
																'<' +
																i18n.t(
																	ds.status,
																	{
																		ns:
																			'force',
																	}
																) +
																'>';
															return (
																<div
																	style={{
																		cursor:
																			'default',
																		overflow:
																			'hidden',
																		textIndent:
																			Flg1 ||
																			Flg2
																				? '20px'
																				: '30px',
																		textOverflow:
																			'ellipsis',
																		whiteSpace:
																			'nowrap',
																		wordBreak:
																			'break-all',
																	}}
																	key={
																		ds.careerID
																	}
																	title={
																		title
																	}
																>
																	{(Flg1 ||
																		Flg2) &&
																		i18n.t(
																			'SkillMap_0013'
																		)}
																	&nbsp;
																	{
																		ds.careerTitle
																	}
																	{'【' +
																		(ds.careerType ===
																			'eラーニング' ||
																		ds.careerType ===
																			'集合研修' ||
																		ds.careerType ===
																			'通信教育' ||
																		ds.careerType ===
																			'カリキュラム' ||
																		ds.careerType ===
																			'資格' ||
																		ds.careerType ===
																			'業務経験' ||
																		ds.careerType ===
																			'スキル診断'
																			? i18n.t(
																					ds.careerType,
																					{
																						ns:
																							'force',
																					}
																			  )
																			: ds.careerType) +
																		'】'}
																	{ds.careerTypeID ===
																		'10' &&
																		ds.rankName &&
																		'(' +
																			ds.rankName +
																			')'}
																	{'<' +
																		i18n.t(
																			ds.status,
																			{
																				ns:
																					'force',
																			}
																		) +
																		'>'}
																</div>
															);
														}
													)}
													{this.state.detailDataN
														.length > 0 && (
														<div>
															--------------------------------------------------------
														</div>
													)}
												</div>
											)}
											{this.state.detailDataN.length >
												0 && (
												<div
													style={{
														display: 'flex',
														flexDirection: 'column',
													}}
												>
													{this.state.detailDataN.map(
														ds => {
															const Flg1: boolean =
																ds.careerTypeID ===
																	'90' &&
																ds.statusId ===
																	'4';
															const Flg2: boolean =
																ds.careerTypeID !==
																	'90' &&
																(ds.statusNum ===
																	7 ||
																	ds.statusNum ===
																		17);
															const title =
																ds.careerTitle +
																'【' +
																(ds.careerType ===
																	'eラーニング' ||
																ds.careerType ===
																	'集合研修' ||
																ds.careerType ===
																	'通信教育' ||
																ds.careerType ===
																	'カリキュラム' ||
																ds.careerType ===
																	'資格' ||
																ds.careerType ===
																	'業務経験' ||
																ds.careerType ===
																	'スキル診断'
																	? i18n.t(
																			ds.careerType,
																			{
																				ns:
																					'force',
																			}
																	  )
																	: ds.careerType) +
																'】' +
																(ds.rankName
																	? '(' +
																	  ds.rankName +
																	  ')'
																	: '') +
																'<' +
																i18n.t(
																	ds.status,
																	{
																		ns:
																			'force',
																	}
																) +
																'>';
															return (
																<div
																	style={{
																		cursor:
																			'default',
																		overflow:
																			'hidden',
																		textIndent:
																			Flg1 ||
																			Flg2
																				? '20px'
																				: '30px',
																		textOverflow:
																			'ellipsis',
																		whiteSpace:
																			'nowrap',
																		wordBreak:
																			'break-all',
																	}}
																	key={
																		ds.careerID
																	}
																	title={
																		title
																	}
																>
																	{(Flg1 ||
																		Flg2) &&
																		i18n.t(
																			'SkillMap_0013'
																		)}
																	&nbsp;
																	{
																		ds.careerTitle
																	}
																	{'【' +
																		(ds.careerType ===
																			'eラーニング' ||
																		ds.careerType ===
																			'集合研修' ||
																		ds.careerType ===
																			'通信教育' ||
																		ds.careerType ===
																			'カリキュラム' ||
																		ds.careerType ===
																			'資格' ||
																		ds.careerType ===
																			'業務経験' ||
																		ds.careerType ===
																			'スキル診断'
																			? i18n.t(
																					ds.careerType,
																					{
																						ns:
																							'force',
																					}
																			  )
																			: ds.careerType) +
																		'】'}
																	{ds.careerTypeID ===
																		'10' &&
																		ds.rankName &&
																		'(' +
																			ds.rankName +
																			')'}
																	{'<' +
																		i18n.t(
																			ds.status,
																			{
																				ns:
																					'force',
																			}
																		) +
																		'>'}
																</div>
															);
														}
													)}
												</div>
											)}
										</div>
										{this.state.loading && (
											<CircularProgress
												size={24}
												className={
													classes.buttonProgress
												}
											/>
										)}
									</Paper>
								</div>
							</Grow>
						</div>
						<div
							style={{
								display: this.state.dloading ? 'none' : 'flex',
								flexDirection: 'column',
							}}
						>
							<div
								className={classes.division1}
								style={{
									backgroundColor: this.state.masterInfo
										.division1Color,
									display: 'flex',
									flexDirection: 'row',
									minWidth:
										this.state.disNowLeveData.length > 0
											? this.state.disNowLeveData[0]
													.length *
													160 -
											  10
											: '99%',
									order: 0,
								}}
								title={
									this.state.disNowDiviData.data.fieldTitle
								}
							>
								<div className={classes.divisionText}>
									{this.state.disNowDiviData.data.fieldTitle}
								</div>
							</div>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
								}}
							>
								{this.state.disNowDiviData.child.map(
									(
										lev2: IDisDivisionData,
										ri: string | number | undefined
									) => {
										return (
											<div
												style={{
													display: 'flex',
													flex: lev2.data.count,
													flexDirection: 'column',
													minWidth:
														lev2.data.count * 160,
													order: lev2.data.order,
												}}
												key={ri + 'c'}
											>
												<div
													className={
														lev2.data.blank
															? ''
															: classes.division2
													}
													style={{
														backgroundColor: this
															.state.masterInfo
															.division2Color,
													}}
													key={ri}
													title={
														lev2.data.blank
															? ''
															: lev2.data
																	.fieldTitle
													}
												>
													<div
														className={
															lev2.data.blank
																? classes.divisionBlank
																: classes.divisionText
														}
													>
														{lev2.data.fieldTitle}
													</div>
												</div>
												<div
													style={{
														display: 'flex',
														flexDirection: 'row',
													}}
													key={ri + 'cc'}
												>
													{lev2.child.map(
														(lev3, rri) => {
															if (
																lev3.data.blank
															) {
																return (
																	<div
																		style={{
																			flex:
																				lev3
																					.data
																					.count,
																			order:
																				lev3
																					.data
																					.order,
																		}}
																		key={
																			rri
																		}
																		className={
																			classes.divisionBlank
																		}
																	>
																		{
																			lev3
																				.data
																				.fieldTitle
																		}
																	</div>
																);
															} else {
																return (
																	<div
																		className={
																			lev3
																				.data
																				.blank
																				? ''
																				: classes.division3
																		}
																		style={{
																			backgroundColor: this
																				.state
																				.masterInfo
																				.division3Color,
																			flex:
																				lev3
																					.data
																					.count,
																			order:
																				lev3
																					.data
																					.order,
																		}}
																		key={
																			rri
																		}
																		title={
																			lev3
																				.data
																				.blank
																				? ''
																				: lev3
																						.data
																						.fieldTitle
																		}
																	>
																		<div
																			className={
																				classes.divisionText
																			}
																		>
																			{
																				lev3
																					.data
																					.fieldTitle
																			}
																		</div>
																	</div>
																);
															}
														}
													)}
												</div>
											</div>
										);
									}
								)}
							</div>
						</div>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								marginTop: '5px',
							}}
						>
							{this.state.disNowLeveData.map((level, ri) => {
								return (
									<div
										key={ri}
										style={{
											display: 'flex',
											flexDirection: 'row',
											justifyContent: 'space-between',
										}}
									>
										{level.map((info, ci) => {
											if (
												info.blank ||
												info.cmcId === ''
											) {
												return (
													<div
														className={`${
															classes.levelCellBase
														} ${
															classes.levelCellBlank
														}`}
														key={ci}
													/>
												);
											} else {
												const levelTitle = info.levelTitle.substring(
													3,
													info.levelTitle.length
												);
												return (
													<div
														className={`${
															classes.levelCellBase
														} ${
															classes.levelCell
														} ${
															info.select
																? classes.levelCellSelected
																: ''
														}`}
														key={ci}
														data-rid={info.cmcId}
														data-inx={ci}
														data-rinx={ri}
														onClick={
															this.handleCellClick
														}
														style={{
															backgroundColor:
																info.bg,
														}}
													>
														<div>
															{i18n.t(
																'SkillMap_0017',
																{ levelTitle }
															)}
															<br />
															{info.contents}
															<br />
														</div>
														<div>
															{info.icon !==
															'' ? (
																<div
																	className={
																		classes.legendCircle
																	}
																	style={{
																		backgroundColor:
																			info.icon,
																		height:
																			'20px',
																		width:
																			'20px',
																	}}
																/>
															) : (
																<div />
															)}
														</div>
													</div>
												);
											}
										})}
									</div>
								);
							})}
						</div>
					</div>
				</div>
			</div>
		);
	}

	/**
	 * 画面サイズ最描画時、詳細ツールTIPを非表示する。
	 */
	protected resizeWrapper = () => {
		const tmp = [...this.state.disNowLeveData];
		for (const row of tmp) {
			for (const col of row) {
				col.select = false;
			}
		}
		this.setState({ disNowLeveData: tmp, open: false, selectLevelId: '' });
	};

	/**
	 * セルクリックイベント
	 * セルをクリックする時、セルの詳細にツールTIPを表示する。
	 * @param event
	 */
	protected handleCellClick = (
		event: React.MouseEvent<HTMLDivElement, MouseEvent>
	) => {
		const tmp = [...this.state.disNowLeveData];
		let s = false;
		let selectLevelId = this.state.selectLevelId;

		// 先ず、選択したのセルID（キャリアマップセルID）を計算する。
		for (const row of tmp) {
			for (const col of row) {
				if (event.currentTarget.dataset.rid === col.cmcId) {
					if (col.cmcId !== this.state.selectLevelId) {
						s = true;
						selectLevelId = col.cmcId;
						col.select = true;
					} else {
						selectLevelId = '';
						col.select = false;
					}
				} else {
					col.select = false;
				}
			}
		}

		const pInfo: any = {};
		const aInfo: any = {};

		// ツールTIPに位置を計算する。
		if (
			this.state.maxCols === 1 ||
			Number(event.currentTarget.dataset.rinx) === this.state.maxRows - 1
		) {
			if (
				this.state.maxRows !== 1 &&
				Number(event.currentTarget.dataset.rinx) !== 0
			) {
				// 一番下のセルをクリックする場合、ツールTIPにセルの上を表示する。
				// ↓
				pInfo.x =
					Number(event.currentTarget.offsetLeft) +
					(Number(event.currentTarget.offsetWidth) - TIP_WIDTH) / 2;
				pInfo.y =
					event.currentTarget.offsetTop - TIP_HEIGHT - ARROW_HEIGHT;
				aInfo.x = TIP_WIDTH / 2;
				aInfo.y = TIP_HEIGHT;
				aInfo.path = '0,0 10,0, 5,10';
				aInfo.offsetLeft = ARROW_WIDTH;
				if (this.isCrossover(Number(event.currentTarget.offsetLeft))) {
					// ツールTIPにセルの上を表示することができない場合、ツールTIPの位置を調整する。
					pInfo.x =
						Number(event.currentTarget.offsetLeft) -
						Math.abs(
							Number(event.currentTarget.offsetWidth) - TIP_WIDTH
						);
					pInfo.y =
						event.currentTarget.offsetTop -
						TIP_HEIGHT -
						ARROW_HEIGHT;
				}
			} else {
				// 一番下一番上のセルをクリックする場合、ツールTIPにセルの下を表示する。
				// ↑
				pInfo.x =
					Number(event.currentTarget.offsetLeft) +
					(Number(event.currentTarget.offsetWidth) - TIP_WIDTH) / 2;
				pInfo.y = event.currentTarget.offsetTop + ARROW_HEIGHT + 90;
				aInfo.x = TIP_WIDTH / 2;
				aInfo.y = ARROW_HEIGHT * -1;
				aInfo.path = '0,10 5,0 10,10';
				aInfo.offsetLeft = ARROW_WIDTH;
				if (this.isCrossover(Number(event.currentTarget.offsetLeft))) {
					// ツールTIPにセルの上を表示することができない場合、ツールTIPの位置を調整する。
					pInfo.x =
						Number(event.currentTarget.offsetLeft) -
						Math.abs(
							Number(event.currentTarget.offsetWidth) - TIP_WIDTH
						);
					pInfo.y =
						event.currentTarget.offsetTop -
						TIP_HEIGHT -
						ARROW_HEIGHT;
				}
			}
		} else {
			if (
				Number(event.currentTarget.dataset.inx) <
				this.state.maxCols - 1
			) {
				// 通常のセルをクリックする場合、ツールTIPにセルの右を表示する。
				// ←
				pInfo.x =
					Number(event.currentTarget.offsetLeft) +
					Number(event.currentTarget.offsetWidth);
				pInfo.y = event.currentTarget.offsetTop - ARROW_WIDTH / 2;
				aInfo.x = 0;
				aInfo.y = Number(event.currentTarget.offsetHeight) / 2;
				aInfo.path = '0,5 10,0, 10,10';
				aInfo.offsetLeft = ARROW_WIDTH;
				if (
					this.isCrossover(
						Number(event.currentTarget.offsetLeft) +
							Number(event.currentTarget.offsetWidth)
					)
				) {
					// ツールTIPにセルの右を表示することができない場合、ツールTIPにセルの上を表示する。
					const off = Math.abs(
						Number(event.currentTarget.offsetWidth) -
							TIP_WIDTH -
							ARROW_WIDTH
					);
					pInfo.x = Number(event.currentTarget.offsetLeft) - off;
					pInfo.y =
						event.currentTarget.offsetTop -
						TIP_HEIGHT -
						ARROW_HEIGHT;
					aInfo.x = (TIP_WIDTH + ARROW_WIDTH + off) / 2;
					aInfo.y = TIP_HEIGHT;
					aInfo.path = '0,0 10,0, 5,10';
					aInfo.offsetLeft = ARROW_WIDTH;
				}
			} else {
				// 一番右のセルをクリックする場合、ツールTIPにセルの左を表示する。
				// →
				pInfo.x =
					Number(event.currentTarget.offsetLeft) -
					TIP_WIDTH -
					ARROW_WIDTH;
				pInfo.y = event.currentTarget.offsetTop - ARROW_WIDTH / 2;
				aInfo.x = TIP_WIDTH;
				aInfo.y = Number(event.currentTarget.offsetHeight) / 2;
				aInfo.path = '0,0 10,5, 0,10';
				aInfo.offsetLeft = 0;
			}
		}

		this.setState({
			arrow: {
				offsetLeft: aInfo.offsetLeft,
				path: aInfo.path,
				x: aInfo.x,
				y: aInfo.y,
			},
			popupInfo: {
				x: pInfo.x,
				y: pInfo.y,
			},
		});

		this.setState({ loading: false, detailDataS: [], detailDataN: [] });

		// セルが選択した場合、セルの詳細情報を検索する。
		if (selectLevelId !== '') {
			this.props
				.fetchCellDetailData(this.props.token, {
					cmId: this.props.cmId,
					cmcId: selectLevelId,
					userId: this.props.AdminView
						? this.props.targetUserId
						: this.props.userId,
				})
				.then(data => {
					// セルの詳細情報を設定する。
					if (this.props.detailData.length > 0) {
						this.setState({
							detailDataN: this.props.detailData.filter(
								o => o.isPriority !== '1'
							),
							detailDataS: this.props.detailData.filter(
								o => o.isPriority === '1'
							),
						});

						this.setState({
							levelInfoNone: '',
							loading: false,
							open: s,
							targetParam: this.getSelectCellInfo(selectLevelId),
						});
					} else {
						this.setState({
							levelInfoNone: i18n.t('SkillMap_0014'),
							loading: false,
							open: s,
							targetParam: this.getSelectCellInfo(selectLevelId),
						});
					}
				});
		} else {
			this.setState({
				arrow: {
					offsetLeft: 0,
					path: '',
					x: 0,
					y: 0,
				},
				popupInfo: {
					x: 0,
					y: 0,
				},
			});
		}

		this.setState({ disNowLeveData: tmp, open: false, selectLevelId });
	};

	/**
	 * 目標設定ボタンクリックイベント
	 */
	protected handleTargetSetClick = () => {
		if (this.state.selectLevelId !== '') {
			this.setState({
				popOpen: true,
				targetParam: this.getSelectCellInfo(this.state.selectLevelId),
			});
		} else {
			this.setState({
				msgCancel: false,
				msgCodes: [{ content: 'LMCM_E_15101' }],
				msgOpen: true,
				msgTitle: i18n.t('SkillMap_0015'),
			});
		}
	};

	/**
	 * メッセージ閉じる処理
	 */
	protected handleMsgClose = () => {
		this.setState({
			msgCancel: false,
			msgCodes: [],
			msgOpen: false,
			msgTitle: '',
		});
	};

	/**
	 * メッセージの「ok」ボタンクリックイベント
	 */
	protected handleMsgOk = () => {
		if (this.state.msgCancel) {
			// 目標設定解除確定時、データを更新する。
			this.props
				.updateTargetInfo(this.props.token, {
					adminView: this.props.AdminView,
					cmId: this.props.cmId,
					cmcId: this.state.selectLevelId,
					comment: '',
					target: 0,
					userId: this.props.AdminView
						? this.props.targetUserId
						: this.props.userId,
				})
				.then(() => {
					this.updateDisData(this.state.selectLevelId, -1, '');
					this.setState({
						msgCancel: false,
						msgCodes: [],
						msgOpen: false,
						msgTitle: '',
						updateInfo: this.props.skillMapData.updateInfo,
					});
				});
		} else {
			this.setState({
				msgCancel: false,
				msgCodes: [],
				msgOpen: false,
				msgTitle: '',
			});
		}
	};

	/**
	 * 目標設定解除ボタンクリックイベント
	 */
	protected handleTargetReSetClick = () => {
		if (this.state.selectLevelId !== '') {
			let nowCell: IDisLevelData = {
				bg: '',
				blank: false,
				cmcId: '',
				comment: '',
				contents: '',
				fieldId: '',
				icon: '',
				level: '',
				levelTitle: '',
				sKey: '',
				select: true,
				targetType: 0,
			};
			for (const row of this.state.disNowLeveData) {
				const findedDatas = row.filter(
					obj => obj.cmcId === this.state.selectLevelId
				);
				if (findedDatas.length > 0) {
					nowCell = findedDatas[0];
					break;
				}
			}

			// 認定されていない、かつ目標が未設定のレベル
			if (nowCell.bg === '' && nowCell.icon === '') {
				this.setState({
					msgCancel: false,
					msgCodes: [{ content: 'LMCM_E_15102' }],
					msgOpen: true,
					msgTitle: i18n.t('SkillMap_0015'),
				});
				return;
			}

			// 認定されているレベルを選択する
			// 仕様変更
			// if (nowCell.bg !== '') {
			// 	this.setState({
			// 		msgCancel: false,
			// 		msgCodes: [{ content: 'LMCM_E_15103' }],
			// 		msgOpen: true,
			// 		msgTitle: 'エラーメッセージ',
			// 	});
			// 	return;
			// }

			// 上記以外
			this.setState({
				msgCancel: true,
				msgCodes: [{ content: 'LMCM_I_15101' }],
				msgOpen: true,
				msgTitle: i18n.t('SkillMap_0016'),
			});
		} else {
			this.setState({
				msgCancel: false,
				msgCodes: [{ content: 'LMCM_E_15101' }],
				msgOpen: true,
				msgTitle: i18n.t('SkillMap_0015'),
			});
		}
	};

	/**
	 * ルート分野変更イベント
	 * @param event
	 */
	protected handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const value: any = event.target.value;
		this.setState({ dloading: true });
		if ('ActiveXObject' in window) {
			this.setState({ zoneFlg: false });
		}
		this.props
			.fetchSkillMapDataByRootId(this.props.token, {
				cmId: this.props.cmId,
				rootId: value,
				userId: this.props.AdminView
					? this.props.targetUserId
					: this.props.userId,
			})
			.then(() => {
				// 取得したのスキルマップデータに表示用なデータを変換する。
				this.changeData(
					this.props.skillMapData.divisionData,
					this.props.skillMapData.levelData,
					value
				);
				this.setState({ selectLevelId: '', open: false });

				if ('ActiveXObject' in window) {
					setTimeout(() => {
						this.setState({ zoneFlg: true });
					}, 200);
				}
			});
	};

	/**
	 *
	 * @param obj
	 */
	protected handlePopClose = (obj: any) => {
		if (obj.submit) {
			this.updateDisData(
				obj.param.cmcId,
				obj.param.target,
				obj.param.comment
			);
		}
		this.setState({
			popOpen: false,
			updateInfo: this.props.skillMapData.updateInfo,
		});
	};

	protected handleHistoryClose = () => {
		this.setState({ historyOpen: false });
	};

	protected handleHistoryClick = () => {
		this.setState({ hloading: true });
		this.props
			.fetchHistoryData(this.props.token, {
				cmId: this.props.cmId,
				userId: this.props.AdminView
					? this.props.targetUserId
					: this.props.userId,
			})
			.then(() => {
				this.setState({
					historyData: this.props.historyList,
					historyOpen: true,
					hloading: false,
				});
			});
	};

	protected handlePopoverClose = (
		event: React.MouseEvent<HTMLDivElement, MouseEvent>
	) => {
		this.setState({ open: false });
	};

	private getSelectCellInfo = (cmcId: string): any => {
		let comment: string = '';
		let target: number = 0;
		let cellLabel: string = '';
		let info: any = {};
		this.state.disNowLeveData.filter(o => {
			const s = o.filter(oo => oo.cmcId === cmcId);
			if (s.length > 0) {
				info = s[0];
			}
			return s.length > 0;
		});

		comment = info.comment;
		if (!isNull(info.targetType)) {
			target = info.targetType;
		}
		const parent = this.props.skillMapData.divisionData.filter(o => {
			return o.fieldId === info.fieldId;
		});
		cellLabel = `【${parent[0].fieldTitle}】${info.levelTitle}`;
		const targetInfo = {
			adminView: this.props.AdminView,
			cellLabel,
			cmId: this.props.cmId,
			cmcId: this.state.selectLevelId,
			comment,
			target,
			userId: this.props.AdminView
				? this.props.targetUserId
				: this.props.userId,
		};
		return targetInfo;
	};

	private updateDisData = (
		cmcId: string,
		target: number,
		comment?: string
	) => {
		const tmp = [...this.state.disNowLeveData];
		for (const row of tmp) {
			for (const col of row) {
				if (col.cmcId === cmcId) {
					col.targetType = target;
					col.icon =
						col.targetType === 0
							? this.state.masterInfo.shortGoalColor
							: col.targetType === 1
							? this.state.masterInfo.longGoalColor
							: ''; // ０：短期目標、１：長期目標
					if (comment !== undefined) {
						col.comment = comment;
					}
					break;
				}
			}
		}
		const tmp2 = [...this.state.disLeveArr];
		for (const data of tmp2) {
			if (data.id === this.state.selectDivision) {
				for (const row of data.datas) {
					for (const col of row) {
						if (col.cmcId === cmcId) {
							col.targetType = target;
							col.icon =
								col.targetType === 0
									? this.state.masterInfo.shortGoalColor
									: col.targetType === 1
									? this.state.masterInfo.longGoalColor
									: ''; // ０：短期目標、１：長期目標
							if (comment !== undefined) {
								col.comment = comment;
							}
							break;
						}
					}
				}
			}
		}
		this.setState({ disNowLeveData: tmp, disLeveArr: tmp2 });
	};

	private isCrossover = (x: number) => {
		if (
			x + TIP_WIDTH + ARROW_WIDTH >
			(window.innerWidth > WINDOW_WIDTH
				? window.innerWidth
				: WINDOW_WIDTH)
		) {
			return true;
		} else {
			return false;
		}
	};

	/**
	 * 分野IDにより、分野対象を取得する。
	 * @param arr 全部の分野対象データ
	 * @param fieldID 分野ID
	 */
	private getChild = (arr: IDData[], fieldID: string) => {
		const t = arr.filter((o: IDData) => {
			return o.parentFieldId === fieldID;
		});

		return t;
	};

	/**
	 * 空のレベルデータを作成する。
	 */
	private makeEmptyDData = (): IDData => {
		const emptyData: IDData = {
			cmId: '',
			count: 0,
			countOfSubject: 0,
			displayOrder: 0,
			fieldId: '',
			fieldId1: 0,
			fieldId2: 0,
			fieldId3: 0,
			fieldLevel: 0,
			fieldTitle: '',
			isLeaf: false,
			lDatas: [],
			lang: '',
			parentFieldId: '',
		};

		return emptyData;
	};

	/**
	 * マップデータを作成する。
	 * @param arr 分野データとレベルデータマージしたデータ
	 * @param fieldID ID
	 */
	private renderTree = (arr: IDData[], fieldID: string): ISkillMapTree => {
		const node: ISkillMapTree = { data: this.makeEmptyDData(), child: [] };
		const datas = arr.filter((o: IDData) => {
			return o.fieldId === fieldID;
		});

		node.data = datas[0];
		const children = this.getChild(arr, datas[0].fieldId);
		if (children.length > 0) {
			for (const child of children) {
				node.child.push(this.renderTree(arr, child.fieldId));
			}
		} else {
			node.child = [];
		}
		if (node.data.lDatas.length === 1) {
			if (node.data.lDatas[0].fieldId === '' && children.length > 0) {
				node.data.lDatas = [];
			}
		}

		return node;
	};

	/**
	 * マップデータを作成する。
	 * @param arr 分野データとレベルデータマージしたデータ
	 */
	private makeTree = (arr: IDData[]): ISkillMapTree[] => {
		const roots = arr.filter((data: IDData) => {
			return isNull(data.parentFieldId);
		});

		const treeDataArr = [];
		for (const root of roots) {
			const treeData = this.renderTree(arr, root.fieldId);
			treeDataArr.push(treeData);
		}

		return treeDataArr;
	};

	/**
	 * 分野データとレベルデータをマージする。
	 * @param dData 分野データ
	 * @param lData レベルデータ
	 */
	private mergeSkillMapData(
		dData: IDivisionData[],
		lData: ILevelData[]
	): IDData[] {
		const smData: IDData[] = [];
		for (const division of dData) {
			const fLevelDatas = lData.filter(o => {
				return o.fieldId === division.fieldId;
			});
			if (fLevelDatas.length > 0) {
				smData.push({ ...division, lDatas: [...fLevelDatas] });
			} else {
				smData.push({
					...division,
					lDatas: [
						{
							cmId: '',
							cmcId: '',
							comment: '',
							contents: '',
							fieldId: '',
							lang: '',
							levelId: '',
							levelTitle: '',
							status: 0,
							targetType: 0,
						},
					],
				});
			}
		}

		return smData;
	}

	/**
	 * ツリーデータから表示用分野データを変換する。
	 * @param mapData ツリーデータ
	 */
	private getDisDivisionData = (mapData: ISkillMapTree): IDisDivision => {
		let count = 0;
		if (mapData.child.length > 0) {
			count = mapData.child.length;
		}
		if (mapData.data.lDatas.length > 0) {
			count++;
		}

		const disData: IDisDivision = {
			blank: false,
			count,
			fieldID: mapData.data.fieldId,
			fieldTitle: mapData.data.fieldTitle,
			order: mapData.data.displayOrder,
		};

		return disData;
	};

	/**
	 * 表示用分野データを作成する。
	 * @param skillData ツリーデータ
	 */
	private renderDisDivisionData(skillData: ISkillMapTree): IDisDivisionData {
		const disData: IDisDivisionData = {
			child: [],
			data: this.getDisDivisionData(skillData),
		};

		if (skillData.child.length > 0) {
			for (const cData of skillData.child) {
				disData.child.push(this.renderDisDivisionData(cData));
			}
		}

		if (skillData.data.lDatas.length > 0) {
			// 空分野データを作成する。
			disData.child.push({
				child: [],
				data: {
					blank: true,
					count: 1,
					fieldID: '',
					fieldTitle: '',
					order: -1,
				},
			});
		}

		return disData;
	}

	/**
	 * 全部の表示用分野データを作成する。
	 * @param treeData ツリーデータ
	 */
	private makeDisplayDivisionData(
		treeData: ISkillMapTree[]
	): IDisDivisionData[] {
		const disData: IDisDivisionData[] = [];
		treeData.map((tree, index) => {
			disData.push(this.renderDisDivisionData(tree));
		});

		return disData;
	}

	/**
	 * 表示用レベルデータを作成する。
	 * @param mapData レベルデータ
	 * @param skey ソートキー( 分野レベル;表示順 eg. 1;0 )
	 */
	private getDisLevelData = (
		mapData: ILevelData,
		skey: string
	): IDisLevelData => {
		const disData: IDisLevelData = {
			bg:
				mapData.status === 9
					? this.state.masterInfo.goalCompleteColor
					: '', // ０：「未着手」、１：「実施中」、９：「終了」
			blank: false,
			cmcId: mapData.cmcId,
			comment: mapData.comment,
			contents: mapData.contents,
			fieldId: mapData.fieldId,
			icon:
				mapData.targetType === 0
					? this.state.masterInfo.shortGoalColor
					: mapData.targetType === 1
					? this.state.masterInfo.longGoalColor
					: '', // ０：短期目標、１：長期目標
			level: mapData.levelId,
			levelTitle: mapData.levelTitle,
			sKey: skey,
			select: false,
			targetType: mapData.targetType,
		};

		return disData;
	};

	/**
	 * 表示用レベルデータを作成する。
	 * @param skillData レベルデータ
	 */
	private renderDisLevelData = (
		skillData: ISkillMapTree,
		order: string
	): IDisLevelData[] => {
		let lData: IDisLevelData[] = [];

		let sOrder = '';
		let sskey = '';

		if (skillData.data.fieldLevel === 1) {
			sOrder = order;
			sskey =
				skillData.data.fieldLevel +
				';' +
				skillData.data.displayOrder +
				'_0_0';
		}
		if (skillData.data.fieldLevel === 2) {
			sOrder = order + '_' + skillData.data.displayOrder;
			sskey =
				skillData.data.fieldLevel +
				';' +
				order +
				'_' +
				skillData.data.displayOrder +
				'_0';
		}
		if (sOrder === '') {
			sOrder = order + '_' + skillData.data.displayOrder;
			sskey = skillData.data.fieldLevel + ';' + sOrder;
		}

		if (skillData.data.lDatas.length > 0) {
			lData = skillData.data.lDatas.map(obj => {
				return this.getDisLevelData(obj, sskey);
			});
		}

		if (skillData.child.length > 0) {
			for (const data of skillData.child) {
				const childDatas = this.renderDisLevelData(data, sOrder);
				if (childDatas.length > 0) {
					lData = lData.concat([...childDatas]);
				}
			}
		}

		return lData;
	};

	/**
	 * グループバイ表示用レベルデータ
	 * @param lDatas 全部の表示用レベルデータ
	 * @param maxLevel 最大レベル
	 */
	private groupByDisLevelData = (
		lDatas: IDisLevelData[],
		maxLevel: number
	): IDisLevelData[][] => {
		const arr: IDisLevelData[][] = [];
		const map: any = {};
		const getMaxLevelInt = (levelStr: string) => {
			return Number((levelStr + '').replace(/\D/g, ''));
		};
		// ソートキーにより、表示用レベルデータをグループする。
		lDatas.forEach(obj => {
			if (map[obj.sKey] !== undefined) {
				map[obj.sKey].push(obj);
			} else {
				map[obj.sKey] = [];
				map[obj.sKey].push(obj);
			}
		});

		// ソート
		const sortKeys = Object.keys(map).sort((a, b) => {
			const s = -1;
			const ss = s * -1;
			const akey = a.split(';');
			const bkey = b.split(';');

			const adKeys = akey[1].split('_');
			const bdKeys = bkey[1].split('_');

			if (Number(adKeys[0]) > Number(bdKeys[0])) {
				return ss;
			} else if (Number(adKeys[0]) < Number(bdKeys[0])) {
				return s;
			} else {
				if (Number(adKeys[1]) > Number(bdKeys[1])) {
					return ss;
				} else if (Number(adKeys[1]) < Number(bdKeys[1])) {
					return s;
				} else {
					if (Number(adKeys[2]) > Number(bdKeys[2])) {
						return ss;
					} else if (Number(adKeys[2]) < Number(bdKeys[2])) {
						return s;
					} else {
						return 0;
					}
				}
			}
		});

		// 空レベルデータを追加する。
		Object.keys(map).forEach(key => {
			for (let i = 1; i <= maxLevel; i++) {
				const s = map[key].filter((obj: { level: string }) => {
					return getMaxLevelInt(obj.level) === i;
				});
				if (s.length === 0) {
					map[key].push({
						bg: '',
						blank: true,
						contents: '',
						icon: '',
						level: i,
						levelTitle: '',
						sKey: '',
						select: false,
					});
				}
			}
			map[key] = map[key].sort((a: any, b: any) => {
				return getMaxLevelInt(a.level) - getMaxLevelInt(b.level);
			});
		});

		// レベルデータを戻す。
		const maxCol = Object.keys(map).length;
		for (let j = 1; j <= maxLevel; j++) {
			const row: IDisLevelData[] = [];
			let blankCount = 0;
			for (let i = 0; i < maxCol; i++) {
				row.push(map[sortKeys[i]][j - 1]);
				if (
					map[sortKeys[i]][j - 1].blank ||
					map[sortKeys[i]][j - 1].cmcId === ''
				) {
					blankCount++;
				}
			}
			if (blankCount !== maxCol) {
				arr.push(row);
			}
		}

		return arr;
	};

	/**
	 * 表示用レベルデータを作成する。
	 * @param treeData ツリーデータ
	 */
	private makeDisplayLevelData = (
		treeData: ISkillMapTree[]
	): IDisLevelList[] => {
		const disData: IDisLevelList[] = [];

		treeData.map((tree, index) => {
			const allDatas = this.renderDisLevelData(
				tree,
				tree.data.displayOrder + ''
			);
			const maxLevel = this.getMaxLevel(allDatas);
			disData.push({
				datas: this.groupByDisLevelData(allDatas, maxLevel),
				id: 'root' + tree.data.fieldId,
			});
		});

		return disData;
	};

	/**
	 * 最大レベルを算出する。
	 * @param lData レベルデータ
	 */
	private getMaxLevel = (lData: IDisLevelData[]) => {
		if (lData.length > 0) {
			let max = lData[0].level;
			lData.forEach(obj => {
				if (obj.level.localeCompare(max) > 0) {
					max = obj.level;
				}
			});
			max = max.replace(/PL/g, '');
			return Number(max);
		} else {
			return 0;
		}
	};

	private setSelectData = (key: string) => {
		const disNDData = this.state.disDiviArr.filter(obj => {
			return 'root' + obj.data.fieldID === key;
		});
		const disNLData = this.state.disLeveArr.filter(obj => {
			return obj.id === key;
		});
		let maxCols = 0;
		let maxRows = 0;
		if (disNLData[0].datas.length > 0) {
			maxCols = disNLData[0].datas[0].length;
			maxRows = disNLData[0].datas.length;
		}

		this.setState({
			disNowDiviData: disNDData[0],
			disNowLeveData: disNLData[0].datas,
			dloading: false,
			maxCols,
			maxRows,
			selectDivision: key,
		});
	};

	/**
	 * スキルマップデータ初期化
	 * @param dData 分野データ
	 * @param lData レベルデータ
	 */
	private initData = (
		dData: IDivisionData[],
		lData: ILevelData[],
		rootDivision: any[]
	) => {
		const mapData = this.mergeSkillMapData(dData, lData);
		const treeData = this.makeTree(mapData);
		const disDData = this.makeDisplayDivisionData(treeData);
		const disLData = this.makeDisplayLevelData(treeData);
		const rootDivisions = rootDivision.map((obj, idx) => {
			return {
				label: obj.label,
				value: obj.value,
			};
		});

		this.setState({
			disDiviArr: disDData,
			disLeveArr: disLData,
			rootDivision: rootDivisions,
		});

		this.setSelectData(rootDivision[0].value);
	};

	/**
	 * スキルマップデータ初期化
	 * @param dData 分野データ
	 * @param lData レベルデータ
	 */
	private changeData = (
		dData: IDivisionData[],
		lData: ILevelData[],
		rootId: string
	) => {
		const mapData = this.mergeSkillMapData(dData, lData);
		const treeData = this.makeTree(mapData);
		const disDData = this.makeDisplayDivisionData(treeData);
		const disLData = this.makeDisplayLevelData(treeData);

		this.setState({
			disDiviArr: disDData,
			disLeveArr: disLData,
		});

		this.setSelectData(rootId);
	};
}

const mapStateToProps = (state: IRootState) => ({
	detailData: state.skillMap.detailData,
	historyList: state.skillMap.historyList,
	skillMapData: state.skillMap.skillMapData,
	token: state.session.token,
	userId: state.session.userAttr.userId,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchCellDetailData: (token: string, arg: IFetchJoken) => {
		const s = SkillMapScenarioFactory.getCellDetail(dispatch, token);
		return s.run(arg);
	},
	fetchHistoryData: (token: string, arg: IFetchHistoryJoken) => {
		const s = SkillMapScenarioFactory.getHistory(dispatch, token);
		return s.run(arg);
	},
	fetchSkillMapData: (token: string, arg: any) => {
		const s = SkillMapScenarioFactory.getSkillMapData(dispatch, token);
		return s.run(arg);
	},
	fetchSkillMapDataByRootId: (token: string, arg: any) => {
		const s = SkillMapScenarioFactory.getSkillMapDataByRootId(
			dispatch,
			token
		);
		return s.run(arg);
	},
	updateTargetInfo: (token: string, arg: any) => {
		const s = SkillMapScenarioFactory.resetTargetInfo(dispatch, token);
		return s.run(arg);
	},
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ISkillMapProp & ISkillMapState;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(SkillMap);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<ISkillMapProp> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/components/SkillMap.tsx